import { TOrderDetailsAction } from './order-details.actions';
import { TOrderDetailsActionType, TOrderDetailsState } from './order-details.models';

export const initialState: TOrderDetailsState = {
  isSyncEnabled: false,

  //header card
  headerInfo: null,
  showHeaderDetailsLoader: false,

  //po card
  poDetailsCardInfo: null,
  showPoDetailsLoader: false,
  poColorSizeQtyInfo: null,

  // process mapping
  showProcessMappingDetailsLoader: false,
  processMappingDetailsCardInfo: null,

  //planning card
  planningCardInfo: null,
  showPlanningCardLoader: false,

  learningCurveCardInfo: null,
  showLearningCurveCardLoader: false,

  allLearningCurves: null,
  showAllLearningCurvesLoader: false,

  viewLearningCurve: null,

  allocationCardInfo: null,
  showOrderAllocationLoader: false,

  orderTimelineCardInfo: null,
  showOrderTimelineLoader: false,

  linewisePlannedQtyCardInfo: null,
  showLinewisePlannedQtyLoader: false,

  operationBreakdownDetailsInfo: null,
  showOperationBreakdownDetailsLoader: false,
};

export function orderListReducer(state = initialState, action: TOrderDetailsAction): TOrderDetailsState {
  switch (action.type) {
    case TOrderDetailsActionType.SetIsSyncEnabled:
      return {
        ...state,
        isSyncEnabled: action.syncEnabled,
      };
    case TOrderDetailsActionType.SetPlanningCardLoader:
      return {
        ...state,
        showPlanningCardLoader: action.showLoader,
      };
    case TOrderDetailsActionType.ClearPlanningCardDetails:
      return {
        ...state,
        planningCardInfo: null,
      };
    case TOrderDetailsActionType.GetPlanningCard:
      return {
        ...state,
        planningCardInfo: null,
      };
    case TOrderDetailsActionType.GetPlanningCardSuccess:
      return {
        ...state,
        planningCardInfo: action.planningCardRes,
      };
    case TOrderDetailsActionType.SetHeaderLoader:
      return {
        ...state,
        showHeaderDetailsLoader: action.showLoader,
      };
    case TOrderDetailsActionType.GetHeader:
      return {
        ...state,
        headerInfo: null,
      };
    case TOrderDetailsActionType.GetHeaderSuccess:
      return {
        ...state,
        headerInfo: action.headerRes,
      };
    case TOrderDetailsActionType.SetLearningCurveCardLoader:
      return {
        ...state,
        showLearningCurveCardLoader: action.showLoader,
      };
    case TOrderDetailsActionType.ClearlearningCurveCardDetails:
      return {
        ...state,
        learningCurveCardInfo: null,
      };
    case TOrderDetailsActionType.GetLearningCurveCard:
      return {
        ...state,
        learningCurveCardInfo: null,
      };
    case TOrderDetailsActionType.GetLearningCurveCardSuccess:
      return {
        ...state,
        learningCurveCardInfo: action.learningCurveCardRes,
      };
    case TOrderDetailsActionType.SetShowAllLearningCurvesLoader:
      return {
        ...state,
        showAllLearningCurvesLoader: action.showLoader,
      };
    case TOrderDetailsActionType.GetAllLearningCurves:
      return {
        ...state,
        allLearningCurves: null,
      };
    case TOrderDetailsActionType.GetAllLearningCurvesSuccess:
      return {
        ...state,
        allLearningCurves: action.learningCurves,
      };
    case TOrderDetailsActionType.GetViewLearningCurveModal:
      return {
        ...state,
        viewLearningCurve: null,
      };
    case TOrderDetailsActionType.GetViewLearningCurveModalSuccess:
      return {
        ...state,
        viewLearningCurve: action.viewLearningCurveRes,
      };
    case TOrderDetailsActionType.SetPoDetailsLoader:
      return {
        ...state,
        showPoDetailsLoader: action.showLoader,
      };
    case TOrderDetailsActionType.ClearPoCardDetails:
      return {
        ...state,
        poDetailsCardInfo: null,
      };
    case TOrderDetailsActionType.GetPoDetailsCard:
      return {
        ...state,
        poDetailsCardInfo: null,
      };
    case TOrderDetailsActionType.GetPoDetailsCardSuccess:
      return {
        ...state,
        poDetailsCardInfo: action.poDetailsCardRes,
      };
    case TOrderDetailsActionType.SetProcessMappingDetailsLoader:
      return {
        ...state,
        showProcessMappingDetailsLoader: action.showLoader,
      };
    case TOrderDetailsActionType.FetchProcessMappingDetailsCard:
      return {
        ...state,
        processMappingDetailsCardInfo: null,
      };
    case TOrderDetailsActionType.FetchProcessMappingDetailsCardSuccess:
      return {
        ...state,
        processMappingDetailsCardInfo: action.payload,
      };
    case TOrderDetailsActionType.GetPoColorSizeQtyDetails:
      return {
        ...state,
        poColorSizeQtyInfo: null,
      };
    case TOrderDetailsActionType.GetPoColorSizeQtyDetailsuccess:
      return {
        ...state,
        poColorSizeQtyInfo: action.poColorSizeQtyRes,
      };
    case TOrderDetailsActionType.SetOrderAllocationLoader:
      return {
        ...state,
        showOrderAllocationLoader: action.showLoader,
      };
    case TOrderDetailsActionType.ClearAllocationCardDetails:
      return {
        ...state,
        allocationCardInfo: null,
      };
    case TOrderDetailsActionType.GetAllocationCardDetails:
      return {
        ...state,
        allocationCardInfo: null,
      };
    case TOrderDetailsActionType.GetAllocationCardDetailsuccess:
      return {
        ...state,
        allocationCardInfo: action.allocationCardInfoRes,
      };

    case TOrderDetailsActionType.SetOrderTimelineLoader:
      return {
        ...state,
        showOrderTimelineLoader: action.showLoader,
      };
    case TOrderDetailsActionType.GetOrderTimelineCardDetails:
      return {
        ...state,
        orderTimelineCardInfo: null,
      };
    case TOrderDetailsActionType.GetOrderTimelineCardDetailsSuccess:
      return {
        ...state,
        orderTimelineCardInfo: action.payload,
      };

    case TOrderDetailsActionType.SetLinewisePlannedQtyLoader:
      return {
        ...state,
        showLinewisePlannedQtyLoader: action.showLoader,
      };
    case TOrderDetailsActionType.GetLinewisePlannedQtyCardDetails:
      return {
        ...state,
        linewisePlannedQtyCardInfo: null,
      };
    case TOrderDetailsActionType.GetLinewisePlannedQtyCardDetailsSuccess:
      return {
        ...state,
        linewisePlannedQtyCardInfo: action.payload,
      };

    case TOrderDetailsActionType.SetOperationBreakdownDetailsLoader:
      return { ...state, showOperationBreakdownDetailsLoader: action.showLoader };
    case TOrderDetailsActionType.GetOperationBreakdownDetails:
      return { ...state, operationBreakdownDetailsInfo: null };
    case TOrderDetailsActionType.GetOperationBreakdownDetailsSuccess:
      return { ...state, operationBreakdownDetailsInfo: action.payload };
    default:
      return state;
  }
}
